import { useEffect, useState } from "react";
import useAPI from "../basic/useAPI";

// Consolidated user alerts (certificate / membership / subscription expiry +
// unpaid packages) from the single backend source `/user-alerts`.
function useUserAlerts(userId) {
  const { callAPI } = useAPI();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const refreshData = async () => {
    if (!userId) return;
    try {
      setIsLoading(true);
      setError(null);
      const result = await callAPI({ url: "/user-alerts", params: { userId } });
      setData(Array.isArray(result) ? result : []);
    } catch (err) {
      console.error("useUserAlerts", err);
      setError(err);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    refreshData();
  }, [userId]);

  return { data, isLoading, error, refreshData };
}

export default useUserAlerts;
